"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var subDays_1 = __importDefault(require("date-fns/subDays"));
var debug_1 = __importDefault(require("debug"));
var constants_1 = require("../../constants");
var format_1 = __importDefault(require("../dates/format"));
var getBettingOptions_1 = __importDefault(require("../getBettingOptions"));
var isOneOfPages_1 = __importDefault(require("../isOneOfPages"));
var getMatchStatusesByLocation_1 = __importDefault(require("./getMatchStatusesByLocation"));
var getMarketStatusesByLocation_1 = __importDefault(require("./getMarketStatusesByLocation"));
var getSportEventTypesByLocation_1 = __importDefault(require("./getSportEventTypesByLocation"));
var getAppliedFilters_1 = __importDefault(require("./getAppliedFilters"));
var debug = debug_1.default('app:utils:getDefaultVariables');
function getDefaultVariables() {
    var _a = getBettingOptions_1.default(), selectedSportIds = _a.selectedSportIds, _b = _a.tournamentIds, tournamentIds = _b === void 0 ? [] : _b;
    var matchStatuses = getMatchStatusesByLocation_1.default();
    var marketStatuses = getMarketStatusesByLocation_1.default();
    var sportEventTypes = getSportEventTypesByLocation_1.default();
    var filters = getAppliedFilters_1.default();
    var defaultVariables = {
        marketStatuses: marketStatuses,
        matchStatuses: matchStatuses,
        sportEventTypes: sportEventTypes,
        sportIds: selectedSportIds,
        tournamentIds: tournamentIds,
    };
    var extendedVariables = {};
    if (isOneOfPages_1.default(constants_1.pages.result)) {
        extendedVariables.dateSortAscending = false;
        extendedVariables.dateFrom = format_1.default(subDays_1.default(new Date(), 1), 'yyyy-MM-dd');
        extendedVariables.withMarketsCount = false;
    }
    var result = __assign(__assign(__assign(__assign({}, constants_1.paginationVariables), defaultVariables), extendedVariables), filters);
    debug('result', result);
    return result;
}
exports.default = getDefaultVariables;
//# sourceMappingURL=getDefaultVariables.js.map